<ng-select
    class="custom"
    [(ngModel)]="value"
    bindLabel="{{ bindLabel }}"
    bindValue="{{ bindValue }}"
    appendTo="body"
    placeholder="{{ placeholder || 'SELECT' | translate }}"
    [clearable]="false"
    [searchable]="false"
    [disabled]="disable"
    [loading]="loading"
    [multiple]="multiple"
    [hideSelected]="multiple"
    (open)="onOpen($event)"
    (close)="onClose($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    (change)="onChange($event)"
    (clear)="onClear()"
    container="body"
    containerClass="tooltip-error"
    [popover]="errorText | translate"
>
    @for (item of items; track item) {
        <ng-option [value]="item.value" [disabled]="item.disabled">
            <span [title]="getItemLabel(item) | translate">{{ getItemLabel(item) | translate }}</span>
        </ng-option>
    }
</ng-select>
